import React, { useEffect, useState, useMemo } from "react";
import PulseLoader from "react-spinners/PulseLoader";
import useAuth from "@/hooks/useAuth";
import EtTrinityConversationInsightsServiceBar from "@/components/ai/EtTrinityConversationInsightsServiceBar"
// 08 Jun 2025
import EtTrinityConversationActionsCompanion from "@/components/ai/EtTrinityConversationActionsCompanion"

// 01 Jun 2025
import { useGetUserConversationsQuery } from "@/features/userConversations/userConversationsApiSlice"

// 13 Jan 2026
import { userConversationsApiSlice } from "@/features/userConversations/userConversationsApiSlice"

// 03 Jun 2025
import { useGetContactTypesQuery } from "@/features/contactTypes/contactTypesApiSlice" 

// 02 Jun 2025
import {
  PlusIcon,
  MinusIcon,
  PencilSquareIcon,
  TrashIcon,
} from "@heroicons/react/24/outline"
import { UserIcon, BuildingOffice2Icon, ClockIcon, PhoneArrowUpRightIcon, AtSymbolIcon } from '@heroicons/react/24/solid'

import moment from "moment";
import { getTimeSince } from "@/utils/EtGetTimeSince"

// 10 Jun 2025
import { CircularProgressbarWithChildren } from 'react-circular-progressbar'
import EtModalUpdateUserAction from '@/components/common/modal/EtModalUpdateUserAction'

// 13 Jan 2026
import { useDispatch } from 'react-redux';

const EtTrinityWeeklyInsights = ({ userId, userOrgId, onClose }) => {

  // First Created - 25 May 2025
  // Author - Atul Pandey
  // Purpose - Let user show insights - weekly accomplishment
  // Updated - 01 Jun 2025 - Refactored to show insights resulting from Client contact conversations
  // Updated - 02 Jun 2025 - Grouped the conversations by contact name
  // Updated - 02 Jun 2025 - Created expand / collapse states
  // Updated - 03 Jun 2025 - Added Contact Types data from RTK query
  // Updated - 03 Jun 2025 - Added time based filtering
  // Updated - 03 Jun 2025 - Added AI chat for further insights
  // Updated - 04 Jun 2025 - Refined the AI chat for further insights
  // Updated - 06 Jun 2025 - Refined the AI chat for insights chat further chat history
  // Updated - 07 Jun 2025 - Refined the display JSX - note details, Trinity Insight Companion, Follow up Companion
  // Updated - 08 Jun 2025 - Started Trinity Actions Companion
  // Updated - 09 Jun 2025 - Genereated Trinity Actions Display
  // Updated - 10 Jun 2025 - Action Details
  // Updated - 27 Jun 2025 - Refined time filtering logic in the isInSelectedPeriod function
  // Updated - 13 Jan 2026 - Refinements for stream generation data refetch using userConversationsApiSlice tags.
  
  
  // console.log('userId', userId)
  // console.log('userOrgId', userOrgId)

  // 1a - State Variables
  const [insightText, setInsightText] = useState({});
  const [contactDetails, setContactDetails] = useState({}); // 02 Jun 2025
  const [expandedNotes, setExpandedNotes] = useState({}); // 02 Jun 2025
  const [activePeriod, setActivePeriod] = useState("today"); // 03 Jun 2025 - for time based filtering
  const [showAIChat, setShowAIChat] = useState(false); // 03 Jun 2025
  const [selectedConversationId, setSelectedConversationId] = useState(null); // 04 Jun 2025
  const [selectedNoteId, setSelectedNoteId] = useState(null); // 04 Jun 2025
  // const [selectedGeneratedInsightHtml, setSelectedGeneratedInsightHtml] = useState(null);// 04 Jun 2025
  // const [selectedContactName, setSelectedContactName] = useState(null); // 04 Jun 2025
  // const [selectedChatHistory, setSelectedChatHistory] = useState([]); // 06 Jun 2025
  const [expandedNoteDetails, setExpandedNoteDetails] = useState({}); // 07 Jun 2025
  const [expandedIndex, setExpandedIndex] = useState(null); // 07 Jun 2025
  const [expandedActions, setExpandedActions] = useState({}); // 08 Jun 2025
  
  const [expandedActionDetails, setExpandedActionDetails] = useState({}); // 10 Jun 2025
  const [expandedProgressTrail, setExpandedProgressTrail] = useState({}); // 10 Jun 2025
  const [showUpdateModal, setShowUpdateModal] = useState(false)           // 10 Jun 2025
  const [selectedAction, setSelectedAction] = useState(null)              // 10 Jun 2025

  const [loading, setLoading] = useState(false); // 30 Jul 2025

  
  // 1c - Select Time period - 03 Jun 2025
  // 27 Jun 2025
  const isInSelectedPeriod = (dateString) => {
  const now = moment();
  const noteDate = moment(dateString);

  const startOfToday = moment().startOf("day");
  const endOfToday = moment().endOf("day");

  const startOfWeek = moment().isoWeekday(1).startOf("day");
  const endOfWeek = endOfToday;

  const startOfMonth = moment().startOf("month");
  const endOfMonth = moment().isSame(now, 'month') ? endOfToday : moment().endOf("month");

  const startOfQuarter = moment().startOf("quarter");
  const endOfQuarter = moment().isSame(now, 'quarter') ? endOfToday : moment().endOf("quarter");

  const startOfYear = moment().startOf("year");
  const endOfYear = moment().isSame(now, 'year') ? endOfToday : moment().endOf("year");

  switch (activePeriod) {
    case 'today':
      return noteDate.isBetween(startOfToday, endOfToday, null, '[]');
    case 'week':
      return noteDate.isBetween(startOfWeek, endOfWeek, null, '[]');
    case 'month':
      return noteDate.isBetween(startOfMonth, endOfMonth, null, '[]');
    case 'quarter':
      return noteDate.isBetween(startOfQuarter, endOfQuarter, null, '[]');
    case 'year':
      return noteDate.isBetween(startOfYear, endOfYear, null, '[]');
    case 'all':
    default:
      return true;
  }
};
 
  // 2a - Get Data from RTK queries
  const {data: userConversationsData, isLoading, refetch: refetchUserConversations} = useGetUserConversationsQuery() // ✅ 07 Jun 2025 - added refetch
  const {data: contactTypesData} = useGetContactTypesQuery() // 03 Jun 2025

  const dispatch = useDispatch(); // 13 Jan 2026

  // 07 Jun 2025
  const selectedConversation = userConversationsData?.entities?.[selectedConversationId];
  const selectedNote = selectedConversation?.userConversationContactNotes?.find(
    n => n._id === selectedNoteId
  );

  const selectedGeneratedInsightHtml = selectedNote?.generatedInsightHtml || "";
  const selectedChatHistory = selectedNote?.insightChatHistory || [];
  const selectedContactName = selectedNote?.userContactId?.contactName || "";


  const extractEntitiesFromAdapter = (dataAdapter) => {
    if (!dataAdapter || !dataAdapter.ids || !dataAdapter.entities) return [];
    return dataAdapter.ids.map((id) => dataAdapter.entities[id]);
  };

  // 2b - Get All Contact Conversations
  const allUserConversations = extractEntitiesFromAdapter(userConversationsData);
  const contactTypes = extractEntitiesFromAdapter(contactTypesData); // 03 Jun 2025

  const allowedContactTypes = contactTypes?.map(item => item.contactTypeName) // 03 Jun 2025

  // ✅ Filter conversations that contain contact notes
  const contactOnlyConversations = allUserConversations.filter(
    convo => Array.isArray(convo?.userConversationContactNotes) && convo?.userConversationContactNotes?.length > 0
  );

  // ✅ Extract all individual contact notes across conversations
  // const allContactNotes = contactOnlyConversations.flatMap(convo => 
  //   convo.userConversationContactNotes.map(note => ({
  //     ...note,
  //     conversationId: convo._id,
  //     weekStarting: convo.weekStarting,
  //     weekEnding: convo.weekEnding
  //   }))
  //   ?.filter(item => 
  //     allowedContactTypes.includes(item?.userContactId?.contactTypeId?.contactTypeName) &&
  //     isInSelectedPeriod(item?.userConversationContactNoteDate) 
  //   ) // 03 Jun 2025

  // ).sort((a, b) => new Date(b.userConversationContactNoteDate) - new Date(a.userConversationContactNoteDate)) // 03 Jun 2025;

  const allContactNotes = extractEntitiesFromAdapter(userConversationsData)
  .filter(convo => Array.isArray(convo?.userConversationContactNotes))
  .flatMap(convo =>
    convo.userConversationContactNotes.map(note => ({
      ...note,
      conversationId: convo._id,
      weekStarting: convo.weekStarting,
      weekEnding: convo.weekEnding,
    }))
  )
  .filter(note =>
    allowedContactTypes.includes(note?.userContactId?.contactTypeId?.contactTypeName) &&
    isInSelectedPeriod(note?.userConversationContactNoteDate)
  )
  .sort((a, b) =>
    new Date(b.userConversationContactNoteDate) - new Date(a.userConversationContactNoteDate)
  );


  // console.log('userContactConversations', contactOnlyConversations)
  // console.log('all Contact Conversations', allContactNotes)
  // console.log('contact Types', contactTypes)
  // console.log('allowd contact Types', allowedContactTypes)

  // 3a - Hande Section Toggle - 02 Jun 2025
  const toggleExpanded = (noteId) => {
    setExpandedNotes(prev => ({
      ...prev,
      [noteId]: !prev[noteId]
    }));
  };

  // 3b - Hande Name Toggle - 02 Jun 2025
  const toggleContact = (contactId) => {
    setContactDetails(prev => ({
      ...prev,
      [contactId]: !prev[contactId]
    }));
  };

  // 3c - Hande Name Toggle - 02 Jun 2025
  const toggleInsight = (insightId) => {
    setInsightText(prev => ({
      ...prev,
      [insightId]: !prev[insightId]
    }));
  };

  // 3d - Hande Note Detail - 07 Jun 2025
  const toggleNoteDetail = (noteDetailId) => {
    setExpandedNoteDetails(prev => ({
      ...prev,
      [noteDetailId]: !prev[noteDetailId]
    }));
  };

  // 3e - Toggle Action Companion - 08 Jun 2025
  const toggleExpandedActions = (noteId) => {
    setExpandedActions(prev => ({
      ...prev,
      [noteId]: !prev[noteId]
    }));
  };

  // 3f - Toggle Action Detail - 10 Jun 2025
  const toggleExpandedActionDetails = (noteId) => {
    setExpandedActionDetails(prev => ({
      ...prev,
      [noteId]: !prev[noteId]
    }));
  };

  // 3g - Toggle Action Progress - 10 Jun 2025
  const toggleExpandedProgressTrail = (noteId) => {
    setExpandedProgressTrail(prev => ({
      ...prev,
      [noteId]: !prev[noteId]
    }));
  };

  
  // 4 - Generate Trinity Prompt from Notes - 03 Jun 2025
  const generateTrinityPromptFromNotes = (notes) => {
    const summaries = notes.map(note => {
      const contact = note?.userContactId?.contactName || 'Unknown';
      const text = note?.userConversationContactNoteText || '';
      return `- ${contact}: ${text}`;
  });

    return `Based on the following client conversations from this week:\n\n${summaries.slice(0, 5).join('\n')}\n\nWhat patterns, strategic opportunities, or risks should I be aware of?`;
  };

  // 4 - Generate Insights for a note 30 Jul 2025 - Moved to EtTrinityWeeklyInsights

  // const handleGenerateInsightForNote = async (note) => {
  //   try {
  //     setLoading(true);

  //     const response = await fetch(
  //       `${process.env.REACT_APP_SERVER_URL}/userConversations/${note.conversationId}/notes/${note._id}/generateInsight`
  //     );
      
  //     const data = await response.json();
      
  //     setInsightText(prev => ({
  //       ...prev,
  //       [note._id]: data.generatedInsightHtml
  //     }));
      
  //     setLoading(false);
      
  //     dispatch(
  //       userConversationsApiSlice.util.invalidateTags([
  //         { type: 'UserConversation', id: 'LIST' }
  //       ])
  //     );
  //   } catch (err) {
  //     console.error("❌ Insight generation failed:", err);
  //     setLoading(false);
  //   }
  // };

  const handleGenerateInsightForNote = async (note) => {
    try {

      setLoading(true); // ✅ Start loading

      const eventSource = new EventSource(
        `${process.env.REACT_APP_SERVER_URL}/userConversations/${note.conversationId}/notes/${note._id}/generateInsight`
      );

      let streamedHtml = "";

      eventSource.onmessage = (event) => {
        const chunk = event.data;
        streamedHtml += chunk;
        setInsightText((prev) => ({
          ...prev,
          [note._id]: (prev[note._id] || "") + chunk,
        }));
      };

      eventSource.addEventListener("end", () => {

        // console.log("✅ Stream ended for note:", note._id);
        eventSource.close();
        setLoading(false); // ✅ Stop loading
        // 13 Jan 2026
        // console.log("🔄 Invalidating tags...");
        dispatch(
          userConversationsApiSlice.util.invalidateTags([
            { type: 'UserConversation', id: 'LIST' }
          ])
        );

        // if (refetchUserConversations) {
        //   refetchUserConversations();
        // }
      });

      eventSource.onerror = (err) => {
        console.error("❌ Insight streaming failed:", err);
        eventSource.close();
        setLoading(false); // ✅ Stop loading on error
      };
    } catch (err) {
      console.error("❌ Insight generation failed:", err);
      setLoading(false); // ✅ Stop loading on error
    }


  };

  useEffect(() => {
  if (!userConversationsData?.ids?.length) return;

  const allConversations = extractEntitiesFromAdapter(userConversationsData);

  allConversations.forEach(convo => {
    convo.userConversationContactNotes?.forEach(note => {

      console.log(`Note ${note._id}: has insight?`, !!note.generatedInsightHtml);
      if (
        note.generatedInsightHtml 
        // && !insightText[note._id] // only hydrate if not already present
      ) {

        console.log(`✅ Setting insightText for note ${note._id}`);
        setInsightText(prev => ({
          ...prev,
          [note._id]: note.generatedInsightHtml
        }));
      }
    });
  });
}, [userConversationsData]);

  // 5 - create Markup - - 02 Jun 2025
  const createMarkup = (htmlContent) => {
    return { __html: htmlContent }
  }

    
  return (
    <div className="p-6 bg-white shadow rounded font-poppins max-w-5xl mx-auto mt-4">
        {/* <EtTrinityServiceBar /> */}
        <div className="flex justify-between items-center mb-4 animate-slide-in-left">
          <div>
            {/* <p className="text-xl font-bold text-gray-800">🧠 Trinity Weekly Insights</p>
            <p className="text-sm text-gray-500">what should you be preparing for....</p> */}
            <p className="text-xl font-bold text-gray-800">🧠 Trinity Conversation Insights</p>
            {/* <p className="text-sm text-gray-500">how are you unlocking your <span className="font-bold text-orange-800 bg-yellow-200 px-2 py-[1px] rounded-full">contact</span> engagements....</p> */}
            <p className="text-sm text-gray-500">how are you unlocking your <span className="font-bold text-orange-800">contact</span> engagements....</p>
          </div>
          
          <button
            onClick={onClose}
            className="text-sm text-blue-600 hover:underline"
          >
            Close
          </button>
        </div>

        {/* Time chips - 03 Jun 2025 ; Added - month, quarter, year  - 27 Jun 2025*/}
        <div className="flex gap-2 my-2">
          {['today', 'week', 'month', 'quarter', 'year', 'all'].map(period => (
            <button
              key={period}
              onClick={() => setActivePeriod(period)}
              className={`px-3 py-1 text-xs font-semibold rounded-full ${
                activePeriod === period ? 'bg-orange-600 text-white' : 'bg-gray-100 text-gray-700'
              }`}
            >
              {period === 'today' ? 'Today' : period === 'week' ? 'This Week' : period === 'month'? 'This Month' : period === 'quarter' ? 'This Qtr' : period === 'year' ? 'This Year' : 'All'}
            </button>
          ))}
        </div>

        {/* Convsrsations with Insights */}
        <div className="border-t text-sm leading-relaxed text-gray-700 max-h-[500px] overflow-y-auto space-y-2">
            {isLoading ? (
              "Trinity is analyzing your week and preparing a reflective summary..."
            ) : allContactNotes.length === 0 ? (
              <p className="text-xs text-gray-500">No client conversations found for this week.</p>
            ) : (
              
              Object.entries(
                allContactNotes.reduce((acc, note) => {
                  const contactName = note?.userContactId?.contactName || "Unknown Contact";
                  if (!acc[contactName]) acc[contactName] = [];
                  acc[contactName].push(note);
                  return acc;
                }, {})
              ).map(([contactName, notes], index) => {
                const sortedNotes = notes.sort((a, b) =>
                  new Date(b.userConversationContactNoteDate) - new Date(a.userConversationContactNoteDate)
                );

                const role = notes[0]?.userContactId?.contactOrgRole?.orgRoleName || "";
                const title = notes[0]?.userContactId?.contactOrgTitle?.orgTitleName || "";
                const contactType = notes[0]?.userContactId?.contactTypeId?.contactTypeName || "";
                const orgName = notes[0]?.userContactId?.contactOrgId?.contactOrganizationName || "";
                const nickName = notes[0]?.userContactId?.contactNickName || "";

                console.log('sortedNotes', sortedNotes)

                return (
                  <div 
                    key={contactName} 
                    className="my-2 py-2 border-b opacity-0 animate-slide-in-left"
                    style={{ animationDelay: `${Math.min(index * 200, 1000)}ms`, animationFillMode: "forwards" }}
                    
                  >

                    <div className="grid grid-cols-5 justify-between items-center gap-2">

                      <div className="col-span-2 flex justify-start items-center">
                        <div
                          className="flex justify-center items-center cursor-pointer rounded-full h-5 w-5 hover:bg-white"
                          onClick={()=>toggleContact(contactName)}
                        >
                          {contactDetails[contactName] ? (
                            <MinusIcon className="h-4 w-4 text-orange-600" />
                          ) : (
                            <PlusIcon className="h-4 w-4 text-orange-600" />
                          )}
                        </div>
                        <div className="mx-1 px-1">
                            <UserIcon className='text-orange-600 h-6 w-6' />
                        </div>
                        <div>
                          <p className="text-sm font-semibold text-gray-800 mx-1 px-1">{contactName}</p>
                          <p className="text-xs text-gray-500 mx-1 px-1 italic">{title} & {role}</p>
                        </div>
                      </div>
                      <div className="col-span-1 flex justify-start items-center">
                        <p className="mx-1 px-1 text-xs text-gray-500">{contactType} </p>
                      </div>
                      <div className="col-span-2 flex justify-start items-center">
                        <div className="">
                            <BuildingOffice2Icon className='text-orange-600 h-6 w-6' />
                          </div>  
                          <p className="mx-1  text-xs font-bold text-gray-400">Org : </p>
                          <p className="mx-1  text-xs text-gray-600">{orgName} </p>
                      </div>
                    </div>

                    {contactDetails[contactName] && sortedNotes?.map((note, idx) => {

                      const noteText = note?.userConversationContactNoteText || ""
                      const noteDate = note?.userConversationContactNoteDate || ""
                      const noteUpdateDate = note?.userConversationContactNoteUpdateDate || ""
                      const insights = note?.generatedInsightHtml || ""
                      // const insights = note?.generatedInsightHtml || insightText[note?._id] || "" // 13 Jan 2026
                      const chatHistory = note?.insightChatHistory || [] // 07 Jun 2025
                      const actions = note?.userActionRefs || [] // 09 Jun 2025

                      // const sanitized = insights.replace(/^<div class='insights'>|<\/div>$/g, '');


                      // console.log('insights', insights)

                      // console.log({
                      //   insights: !!insights,
                      //   insightText: insightText[note._id],
                      //   noteId: note._id
                      // });
                      
                      return(
                      <div key={idx} className="bg-gray-100 rounded shadow-sm border border-gray-100 m-1 p-2">
                        
                        <div className="grid grid-cols-7 justify-between items-center m-1 p-1">
                          <div className="col-span-1 flex justify-start items-center">
                            <div
                              className="flex justify-center items-center cursor-pointer rounded-full h-5 w-5 hover:bg-white"
                              onClick={()=>toggleExpanded(note._id)}
                            >
                              {expandedNotes[note._id] ? (
                                <MinusIcon className="h-4 w-4 text-orange-600" />
                              ) : (
                                <PlusIcon className="h-4 w-4 text-orange-600" />
                              )}
                            </div>
                            <p className="mx-1 px-1 text-lg font-bold text-gray-600">{idx +1}.</p>
                            <div className="">
                              <p className="text-[8px] mx-1 rounded-full px-1 my-[1px] py-[1px] bg-lime-200 w-full">
                                {getTimeSince(noteUpdateDate)}
                              </p>
                              <p className="text-[7px] mx-1 italic px-1 py-[1px] text-gray-400">last updated</p>
                            </div>

                          </div>
                          <div className="col-span-4 flex justify-start items-center">
                            <p className="mx-1 px-1 text-xs font-bold text-gray-600">Conversation: </p>
                            <div
                              dangerouslySetInnerHTML={createMarkup(noteText)}
                              className="text-[11px] text-gray-700 m-1 p-1 truncate max-w-full line-clamp-1"
                            ></div>
                          </div>
                          <div className="col-span-2 flex justify-end items-center">
                            <ClockIcon className="h-5 w-5 text-lime-600" />
                            <p className="text-[10px] text-orange-600 font-bold mx-1 px-1">
                                Created:
                            </p>
                            <p className="text-[10px] text-gray-500">
                                {moment(noteDate).format('DD MMM, hh:mm A')}
                            </p>
                          </div>
                        </div>
                        
                        {expandedNotes[note._id] && (
                          <div>
                            <div className="p-2 m-2 py-1 my-1 bg-white rounded">

                              <div className="flex justify-start items-center">
                                  <div
                                    className="flex justify-center items-center cursor-pointer rounded-full h-5 w-5 hover:bg-white"
                                    onClick={()=>toggleNoteDetail(note._id)}
                                  >
                                    {expandedNoteDetails[note._id] ? (
                                      <MinusIcon className="h-4 w-4 text-orange-600" />
                                    ) : (
                                      <PlusIcon className="h-4 w-4 text-orange-600" />
                                    )}
                                  </div>
                                  {/* <p className="mx-1 px-1 font-bold">Conversation Details:</p>      */}
                                  <div>
                                    <p className="mx-1 px-1 mt-1 pt-1 font-bold">Conversation Details:</p> 
                                    <p className="mx-1 px-1 text-[10px] text-gray-500">
                                      Details of this conversation with <span className="font-semibold">{nickName}</span>.
                                      </p>
                                  </div>
                                      
                                </div>

                              {expandedNoteDetails[note._id] && (     
                              <div
                                className="m-1 p-1 border-t pt-4 text-xs fix-nested-lists"
                                dangerouslySetInnerHTML={createMarkup(noteText)}
                              ></div>
                              )} 
                            
                            </div>

                            <div className="p-2 m-2 py-1 my-1 bg-white rounded">

                              <div className="flex justify-start items-center">
                                  <div
                                    className="flex justify-center items-center cursor-pointer rounded-full h-5 w-5 hover:bg-white"
                                    onClick={()=>toggleInsight(note._id)}
                                  >
                                    {insightText[note._id] ? (
                                      <MinusIcon className="h-4 w-4 text-orange-600" />
                                    ) : (
                                      <PlusIcon className="h-4 w-4 text-orange-600" />
                                    )}
                                  </div>
                                  {/* <p className="mx-1 px-1 font-bold">🧠 Trinity Insight Companion</p>      */}
                                  {/* <p className="mx-1 px-1 font-bold">Trinity Insights Companion</p>      */}
                                  {/* <p className="m-1 p-1 font-bold">Trinity Insights Companion</p>   */}
                                  <div>
                                    <p className="mx-1 px-1 mt-1 pt-1 font-bold">Trinity Insights Companion</p> 
                                    <p className="mx-1 px-1 text-[10px] text-gray-500">
                                      What you  can glean from this conversation with <span className="font-semibold">{nickName}</span>.
                                    </p>
                                  </div>
                                       
                                </div>

                                  {/* {insights && insightText[note._id] && (
                                    <div 
                                    className="text-xs pt-2 mt-2 border-t"
                                    dangerouslySetInnerHTML={createMarkup(insights)}  
                                    /> 
                                  )} */}

                                  {!insights && insightText[note._id] &&(
                                  <div className="flex items-center justify-between text-[11px] text-gray-500 italic border-t pt-2 mt-2">
                                    <p>No insight yet for this note.</p>
                                      {loading ? (
                                        <div className="flex bg-orange-600 items-center space-x-2 text-xs text-gray-200 italic mb-2 px-2 py-1 rounded">
                                          <span>Generating insight...</span>
                                          <PulseLoader color="#fff" size={6} />
                                      </div>
                                      ): (
                                        <button
                                        onClick={() => handleGenerateInsightForNote(note)}
                                        className="bg-orange-500 text-white px-2 py-1 rounded hover:bg-orange-600"
                                      >
                                        + Generate Trinity Insight
                                      </button>
                                      )}
                                      
                                  </div>
                                  )} 
                                   {/* {insightText[note._id] && (
                                    <div 
                                      className="text-xs pt-2 mt-2 border-t fix-nested-lists"
                                      dangerouslySetInnerHTML={createMarkup(sanitized)}  
                                    />
                                  )} */}
                                   {insights && insightText[note._id] && (
                                    
                                    <div 
                                    className="text-xs pt-2 mt-2 border-t fix-nested-lists"
                                    dangerouslySetInnerHTML={createMarkup(insights)}  
                                    /> 
                                  )}
                            </div>

                            {/* 04 Jun 2025 - AI Prompt Interface for each note after an insight is generated */}
                            <div className="p-2 m-2 py-1 my-1 bg-white rounded">
                              <div className="flex justify-start items-center">
                                <div
                                    className="flex justify-center items-center cursor-pointer rounded-full h-5 w-5 hover:bg-white"
                                    onClick={() => {
                                      setSelectedConversationId(note.conversationId);
                                      setSelectedNoteId(note._id);
                                      // setSelectedGeneratedInsightHtml(note.generatedInsightHtml);
                                      // setSelectedContactName(contactName);
                                      // setSelectedChatHistory(note.insightChatHistory || [])
                                      setShowAIChat(prev => !prev);
                                    }}
                                  >
                                    {showAIChat ? (
                                      <MinusIcon className="h-4 w-4 text-orange-600" />
                                    ) : (
                                      <PlusIcon className="h-4 w-4 text-orange-600" />
                                    )}
                                  </div>
                                   {/* <p className="m-1 p-1 font-bold">Trinity Follow up Companion</p> */}
                                   <div>
                                    <p className="mx-1 px-1 mt-1 pt-1 font-bold">Trinity Follow up Companion</p> 
                                    <p className="mx-1 px-1 text-[10px] text-gray-500">
                                      What you can do next with <span className="font-semibold">{nickName}</span>.
                                    </p>     
                                   </div>
                                                          
                              </div>

                              {/* Show chat history in accordion style */}
                              {showAIChat && chatHistory?.length > 0 &&
                                [...chatHistory]
                                  .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt)) // ✅ sort first
                                  .reduce((pairs, item, idx, arr) => {
                                    if (item.role === 'user' && arr[idx + 1]?.role === 'assistant') {
                                      pairs.push({ user: item, assistant: arr[idx + 1] });
                                    }
                                    return pairs;
                                  }, [])
                                  .map((pair, index) => (
                                    <div key={index} className="bg-gray-100 rounded p-2 m-2">
                                      <div
                                        className="flex items-center cursor-pointer"
                                        onClick={() =>
                                          setExpandedIndex(expandedIndex === index ? null : index)
                                        }
                                      >
                                        {expandedIndex === index ? (
                                          <MinusIcon className="h-4 w-4 text-orange-600" />
                                        ) : (
                                          <PlusIcon className="h-4 w-4 text-orange-600" />
                                        )}
                                        <p className="font-bold text-sm text-gray-700 mx-2">You:</p>
                                        <p
                                          className="text-gray-600 text-xs line-clamp-1"
                                          dangerouslySetInnerHTML={createMarkup(pair.user.content)}
                                        ></p>
                                      </div>

                                      {expandedIndex === index && (
                                        <div className="mt-2 ml-6 border-l-2 border-orange-300 pl-3">
                                          <div className="bg-white rounded p-2">
                                            <p className="text-xs font-bold text-gray-700 mb-1">Trinity:</p>
                                          <p
                                            className="text-gray-600 text-xs"
                                            dangerouslySetInnerHTML={createMarkup(pair.assistant.content)}
                                          ></p>
                                          </div>
                                          
                                        </div>
                                      )}
                                    </div>
                                  ))}

                              {/* 04 Jun 2025 - Load TrinityConversationInsightsServiceBar */}
                              {showAIChat && selectedConversationId && selectedNoteId && (
                                <div className="">
                                  <EtTrinityConversationInsightsServiceBar
                                    userId={userId}
                                    conversationId={selectedConversationId}
                                    noteId={selectedNoteId}
                                    contactName={selectedContactName}
                                    generatedInsightHtml={selectedGeneratedInsightHtml}
                                    insightChatHistory={selectedChatHistory} // 06 Jun 2025
                                    onClose={() => {
                                      setShowAIChat(false);
                                      setSelectedConversationId(null);
                                      setSelectedNoteId(null);
                                      // setSelectedGeneratedInsightHtml(null);
                                      // setSelectedChatHistory([]);
                                    }}
                                    onRefetchChatHistory={refetchUserConversations} // 07 Jun 2025
                                  />
                                </div>
                              )}
                            </div>

                            {/* 08 Jun 2025 - Trinity Actions Companion */}
                            <div className="p-2 m-2 py-1 my-1 bg-white rounded">
                              <div className="flex justify-start items-center">
                                  <div
                                    className="flex justify-center items-center cursor-pointer rounded-full h-5 w-5 hover:bg-white"
                                    onClick={() => toggleExpandedActions(note._id)}
                                  >
                                    {expandedActions[note._id] ? (
                                      <MinusIcon className="h-4 w-4 text-orange-600" />
                                    ) : (
                                      <PlusIcon className="h-4 w-4 text-orange-600" />
                                    )}
                                  </div>
                                   {/* <p className="m-1 p-1 font-bold">Trinity Follow up Companion</p> */}
                                   <div>
                                    <p className="mx-1 px-1 mt-1 pt-1 font-bold">Trinity Actions Companion</p> 
                                    <p className="mx-1 px-1 text-[10px] text-gray-500">
                                      Your follow up actions to engage with <span className="font-semibold">{nickName}</span>.
                                    </p>     
                                   </div>                            
                              </div>

                              {expandedActions[note._id] && actions?.length === 0 && (
                                <EtTrinityConversationActionsCompanion
                                  conversationId={note.conversationId}
                                  noteId={note._id}
                                  userId={userId}
                                  userOrgId={userOrgId}
                                />
                              )}

                              {/* 09 Jun 2025 - Generated Actions Display */}
                              {expandedActions[note._id] && actions?.length > 0 && actions?.map((action, actionIndex) => {
                                
                                const actionId = action?.userActionId?._id || null
                                const trailId = action?.userActionId?.trailId || null
                                const sessionId = action?.userActionId?.sessionId || null
                                const actionTypeId = action?.userActionId?.actionTypeId || null
                                const actionName = action?.userActionId?.userActionName || ""
                                const actionDesc = action?.userActionId?.userActionDesc || ""
                                const completeBy = action?.userActionId?.completeBy || ""
                                const progress = action?.userActionId?.userActionProgress || 0
                                const actionNotes = action?.userActionId?.userActionNotes || []
                                const createdAt = action?.userActionId?.createdAt || ""
                                const updatedAt = action?.userActionId?.updatedAt || ""
                                // Action Data for Action Update
                                const actionData = {
                                  _id: actionId,
                                  userId: userId,
                                  userOrgId: userOrgId,
                                  trailId: trailId,
                                  sessionId: sessionId,
                                  actionTypeId: actionTypeId,
                                  userActionName: actionName,
                                  userActionDesc: actionDesc,
                                  completeBy:completeBy,
                                }
                                
                                return(
                                  <div key={action._id + actionIndex} className="bg-gray-200 rounded m-1 p-1">
                                    {/* Action Header Bar */}
                                    <div className="grid grid-cols-8 justify-between items-center m-1 p-1">
                                      <div className="col-span-1 flex justify-start items-center">
                                        <div
                                          className="flex justify-center items-center cursor-pointer rounded-full h-5 w-5 hover:bg-white"
                                          onClick={()=>toggleExpandedActionDetails(action._id)}
                                        >
                                          {expandedActionDetails[action._id] ? (
                                            <MinusIcon className="h-4 w-4 text-orange-600" />
                                          ) : (
                                            <PlusIcon className="h-4 w-4 text-orange-600" />
                                          )}
                                        </div>
                                        <p className="mx-1 px-1 text-lg font-bold text-gray-600">{actionIndex +1}.</p>
                                        <div className="">
                                          <p className="text-[8px] mx-1 rounded-full px-1 my-[1px] py-[1px] bg-lime-200 w-full">
                                            {getTimeSince(updatedAt)}
                                          </p>
                                          <p className="text-[7px] mx-1 italic px-1 py-[1px] text-gray-600">last updated</p>
                                        </div>

                                      </div>
                                      <div className="col-span-4 flex justify-start items-center">
                                        <p className="mx-1 px-1 text-xs font-bold text-gray-600">Action: </p>
                                        <div
                                          dangerouslySetInnerHTML={createMarkup(actionName)}
                                          className="text-[11px] text-gray-700 m-1 p-1 truncate max-w-full line-clamp-1"
                                        ></div>
                                      </div>

                                      <div className='col-span-1 flex justify-center items-center'>
                                        <div className='h-10 w-10 z-0 relative'>
                                          <CircularProgressbarWithChildren
                                            value={progress}
                                            circleRatio={0.75}
                                            styles={{
                                              path: { stroke: '#552a9a', transform: 'rotate(-135deg)', transformOrigin: 'center center' },
                                              trail: { stroke: '#d6d6d6', transform: 'rotate(-135deg)', transformOrigin: 'center center' }
                                            }}
                                          >
                                            <div><p className='text-xs font-bold text-orange-600'>{progress}%</p></div>
                                          </CircularProgressbarWithChildren>
                                        </div>
                                      </div>


                                      <div className="col-span-2 flex justify-end items-center">
                                        <div className="flex justify-between items-center">
                                          <div className="flex justify-start items-center">
                                            <ClockIcon className="h-5 w-5 text-lime-600" />
                                              <p className="text-[10px] text-gray-600 font-bold mx-1 px-1">
                                                  Complete By:
                                              </p>
                                              <p className="text-[10px] rounded-full mx-[2px] font-semibold ml-1 px-1 bg-white border border-orange-600 hover:bg-orange-600 hover:text-white text-gray-800">
                                                  {/* {moment(completeBy).format('DD MMM, hh:mm A')} */}
                                                  {moment(completeBy).format('DD MMM YYYY')}
                                              </p>
                                          </div>

                                          <div className="ml-1 pl-1">
                                            <div className="rounded-full flex justify-center items-center h-6 w-6 hover:bg-white">
                                              <PencilSquareIcon
                                                className="h-5 w-5 p-[2px] text-orange-600 cursor-pointer"
                                                onClick={() => {
                                                  setSelectedAction(actionData)
                                                  setShowUpdateModal(true)
                                                }}
                                              />
                                            </div>
                                          </div> 
                                        </div>    
                                      </div>
                                    </div>
                                                                     
                                    {/* Action & Progress Details */}
                                    {expandedActionDetails[action._id] && (
                                    
                                    <div>
                                      <div className="bg-orange-50 rounded m-1 p-1">
                                        <p className="mx-1 px-1 font-bold">Details</p>
                                        {/* <p className="m-1 p-1 text-xs leading-4 text-gray-600">{actionName} {actionDesc}</p> */}
                                        {/* <div className="m-1 p-1 text-xs leading-4 text-gray-600">
                                          <p className="inline-block">{actionName}</p>
                                          <div dangerouslySetInnerHTML={createMarkup(actionDesc)} />
                                        </div> */}

                                        <div className="m-1 p-1 text-xs leading-4 text-gray-600">
                                          <span className="">{actionName}</span> <span dangerouslySetInnerHTML={createMarkup(" " + actionDesc)} />
                                        </div>

                                        <div className="flex justify-end items-center border-t py-2">
                                            <div className="flex justify-start items-center mx-1 px-1">
                                              <ClockIcon className="h-5 w-5 text-lime-600" />
                                                <p className="text-[10px] text-orange-600 font-bold mx-1 px-1">
                                                    Created:
                                                </p>
                                                <p className="text-[10px] text-gray-500">
                                                    {moment(createdAt).format('DD MMM, hh:mm A')}
                                                </p>
                                            </div>
                                            <div className="flex justify-start items-center mx-1 px-1">
                                              <ClockIcon className="h-5 w-5 text-lime-600" />
                                                <p className="text-[10px] text-orange-600 font-bold mx-1 px-1">
                                                    Updated:
                                                </p>
                                                <p className="text-[10px] text-gray-500">
                                                    {moment(updatedAt).format('DD MMM, hh:mm A')}
                                                </p>
                                            </div>
                                          </div>
                                      </div>

                                      <div className="bg-white rounded m-1 p-1">

                                        <div className="flex justify-start items-center">
                                          <div
                                              className="flex justify-center items-center cursor-pointer rounded-full h-5 w-5 hover:bg-white"
                                              onClick={()=>toggleExpandedProgressTrail(action._id)}
                                            >
                                              {expandedProgressTrail[action._id] ? (
                                                <MinusIcon className="h-4 w-4 text-orange-600" />
                                              ) : (
                                                <PlusIcon className="h-4 w-4 text-orange-600" />
                                              )}
                                            </div>

                                            <div>
                                              <p className="mx-1 px-1 font-bold">Progress Trail</p>
                                              <p className="mx-1 px-1 text-xs">See the progress of this action</p>
                                            </div>  
                                            

                                        </div>

                                        
                                        {/* Trail Placeholder */}
                                        {expandedProgressTrail[action._id] && actionNotes?.length > 0 && (
                                          <div className="border-t mt-2 pt-2">
                                            
                                            {actionNotes
                                              ?.slice()
                                              ?.sort((a, b) => new Date(b.actionNoteDate) - new Date(a.actionNoteDate))
                                              ?.map((note, noteIndex) => {
                                                const noteText = note?.actionNoteText || ""
                                                const noteDate = note?.actionNoteDate || ""
                                                const noteProgress = note?.actionNoteProgress || 0

                                                return (
                                                  <div key={note._id + noteIndex} className='bg-gray-50 rounded my-1 p-2 border-b'>
                                                    <div className='grid grid-cols-5 justify-start items-center'>
                                                      <div className="col-span-1 flex flex-col justify-center items-center ">
                                                        <div className='h-10 w-10 mr-2'>
                                                        <CircularProgressbarWithChildren
                                                          value={noteProgress}
                                                          circleRatio={0.75}
                                                          styles={{
                                                            path: { stroke: '#552a9a', transform: 'rotate(-135deg)', transformOrigin: 'center center' },
                                                            trail: { stroke: '#d6d6d6', transform: 'rotate(-135deg)', transformOrigin: 'center center' }
                                                          }}
                                                        >
                                                          <div><p className='text-[12px] font-bold'>{noteProgress}%</p></div>
                                                        </CircularProgressbarWithChildren>
                                                      </div>
                                                        <p className='text-[10px] rounded-full px-2 my-[1px] py-[1px] bg-yellow-300 inline-block'>{getTimeSince(noteDate)}</p>
                                                      </div>
                                                      <div className="col-span-4 flex-1">
                                                        <p className='m-1 p-1'>{noteText}</p>
                                                        
                                                      </div>
                                                    </div>
                                                  </div>
                                                )
                                              })}
                                          </div>
                                        )}

                                        {expandedProgressTrail[action._id] && actionNotes?.length === 0 && (
                                          <p className='text-xs italic text-gray-500'>No progress updates yet.</p>
                                        )}

                                      </div>

                                    </div>
                                    )}
                                    {/* Modal to update the action - 04 Apr 2025 */}
                                          {showUpdateModal && selectedAction && (
                                            <EtModalUpdateUserAction
                                              isOpen={showUpdateModal}
                                              onClose={() => {
                                                setShowUpdateModal(false);
                                                setSelectedAction(null);
                                              }}
                                              actionId={selectedAction._id}
                                              actionData={selectedAction}
                                              refetchUserActions={refetchUserConversations}
                                            />
                                          )}
                                    
                                  </div>
                                )
                              })}
                            </div>
                          </div>
                        )}
                      </div>
                    )})}
                  </div>
                );
              })
            )}
        </div>
    </div>
  );
};

export default EtTrinityWeeklyInsights;